import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components";
import { MonetizationOn as MuiMonetizationOn, Error as MuiError, Refresh as MuiRefresh } from "@material-ui/icons";
import styles from "../../styles";

const ShowAll = styled.div`${styles.ShowAll}`;
const MonetizationOn = styled(MuiMonetizationOn)`${styles.MonetizationOn}`;
const Error = styled(MuiError)`${styles.ErrorIcon}`;
const Refresh = styled(MuiRefresh)`${styles.RefreshHeader}`;
const TableHeader = styled.div`
  ${styles.RatesTableHeader}
  grid-template-columns: ${p => p.showOverride ? "1fr auto auto auto 125px" : "1fr auto auto 125px"};
  @media (max-width: 600px) {
    & { grid-template-columns: ${p => p.showOverride ? "1fr auto auto auto 120px" : "1fr auto auto 118px"}; }
  }
`;
const HeaderItem = styled.span`
  ${styles.RatesHeaderItem}
  ${p => p.billable && "margin-right: 62px"}
  ${p => p.showOverride && "margin-right: 4px"}
  @media (max-width: 600px) {
    & { ${p => p.showOverride && p.refresh && "margin-right: 2px"} }
  }
`;

class RatesHeader extends React.Component {
  componentDidMount = () => $('.checkbox_tooltip').tooltip();

  render () {
    const {
      expanded,
      toggleExpanded,
      showOverride,
      clientName: clientNameOriginal,
    } = this.props;
    const clientName = clientNameOriginal.toLowerCase();

    return (
      <TableHeader {...{showOverride}}>
        <span />
        <HeaderItem
          {...{showOverride}}
          refresh
          className="checkbox_tooltip"
          title={`The icon below allows you to reset the billing rate to inherit from it's parent rate.`}
        >
          <Refresh />
        </HeaderItem>
        {
          showOverride &&
          <HeaderItem
            {...{showOverride}}
            className="checkbox_tooltip"
            title={`The checkboxes below determine if the service rate should override the ${clientName} rate.`}
          >
            <Error />
          </HeaderItem>
        }
        <HeaderItem
          billable
          className="checkbox_tooltip"
          title="The checkboxes below determine if the rate is billable or non-billable."
        >
          <MonetizationOn />
        </HeaderItem>
        <ShowAll onClick={() => toggleExpanded(!expanded)}>
          {expanded ? "Show less" : "Show All"}
        </ShowAll>
      </TableHeader>
    );
  }
}

RatesHeader.propTypes = {
  expanded: PropTypes.bool,
  toggleExpanded: PropTypes.func,
  showOverride: PropTypes.bool,
};
export default RatesHeader;
